<template>
  <nav-accordion v-click-outside="close" class="secondary-list">
    <nav-collapsible
      v-for="(link, index) in links"
      :key="index"
      :is-open="isCollapsibleOpen(link, index)"
      class="secondary-list__item"
      variant="secondary"
      data-track-as="nav-collapsible"
      :data-track-text="link.title"
      @open="onOpen(index)"
      @close="onClose(index)"
    >
      <template #action="slotProps">
        <list-title
          :title-label="link.title"
          :active="link.active"
          :open="slotProps.open"
          :has-toggle="isMobile && !!link.sublinks"
          :link-href="isMobile && !!link.sublinks ? null : link.href"
          :linked="!link.sublinks"
          tabbable
          large
          @trigger="slotProps.toggle"
        />
      </template>
      <template #content="slotProps">
        <div class="secondary-list__content">
          <tertiary-list
            v-if="link.sublinks"
            :links="link.sublinks"
            :secondary-open="slotProps.open"
          />
        </div>
      </template>
    </nav-collapsible>
  </nav-accordion>
</template>

<script>
/* Directives */
import clickOutside from '@/directives/click-outside'

import ListTitle from './ListTitle'
import NavAccordion from './NavAccordion'
import NavCollapsible from './NavCollapsible'
import TertiaryList from './TertiaryList'

export default {
  name: 'SecondaryList',

  directives: {
    clickOutside,
  },

  components: {
    TertiaryList,
    ListTitle,
    NavAccordion,
    NavCollapsible,
  },

  props: {
    links: {
      type: Array,
      required: true,
    },
  },

  data: function () {
    return {
      openKeys: new Set(),
    }
  },
  computed: {
    isMobile() {
      return !this.$mq['lg!']
    },
  },
  mounted() {
    window.addEventListener('scroll', this.scrollHandler, {
      capture: true,
      passive: true,
    })
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.scrollHandler, {
      capture: true,
      passive: true,
    })
  },
  methods: {
    onOpen(key) {
      this.close()
      this.openKeys.add(key)
    },
    onClose(key) {
      this.openKeys.delete(key)
    },
    close() {
      if (this.isMobile) {
        return
      }
      this.openKeys = new Set()
    },
    isCollapsibleOpen(link, index) {
      return (
        (this.isMobile && link.active && !!link.sublinks) ||
        this.openKeys.has(index)
      )
    },
    scrollHandler() {
      this.close()
    },
  },
}
</script>

<style lang="postcss" scoped>
.secondary-list {
  display: flex;
  list-style-type: none;
  flex-direction: column;
  border-top: none;
}

.secondary-list__item {
  display: inline-block;
  cursor: pointer;
  border-bottom: 1px solid var(--c-secondary-neutral-3);

  /*.nav-collapsible--secondary {*/
  margin-bottom: 0;
  transition: margin-bottom 300ms ease-in-out;
}

>>> .secondary-list__item.nav-collapsible--open {
  margin-bottom: var(--spacing-8);

  &:last-child {
    margin-bottom: 0;
  }
}

.secondary-list__content {
  display: flex;
  flex-direction: column;
}

@media (--lg) {
  .secondary-list {
    flex-direction: row;
    flex-wrap: nowrap;
  }

  .secondary-list__item {
    position: static;
    border-bottom: none;
  }

  >>> .secondary-list__item.nav-collapsible--open {
    margin-bottom: 0;
  }
}
</style>
